/**
 * @generated SignedSource<<0c044cf3e12155f0623d7a4c5355d14c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "updateProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditContactInformationFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditContactInformationFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0703605883c588f846ff25127624843e",
    "id": null,
    "metadata": {},
    "name": "EditContactInformationFormMutation",
    "operationKind": "mutation",
    "text": "mutation EditContactInformationFormMutation(\n  $input: UpdateProfileInput!\n) {\n  updateProfile(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "cc093601d6dd0e16fcd7b143a9611c3e";

module.exports = node;
